import { useSearchParams } from '@suntex.core/nav'
import { useModuleBySlug } from '@suntex.fim/framework'
import { ModuleLayout } from '@suntex.fim/modules'
import { usePlayerDashboardPath } from '@suntex.fim/nav'
import { usePlayer } from '@suntex.fim/player'
import { useEffectAddScript } from '@suntex.fim/ui'

import { fimCdnAnimateUrl } from '../../../utils/fimUtils'
import Canvas, { CanvasProperties, ICanvasParameters } from '../Shared/Canvas'

import { Loading } from './Module'

export interface IBonusGamesProps {
  slug: string
}

const ApiMethods = {
  get: '/api/player/get-progress',
  update: '/api/player/update-progress'
}

const ModuleConstants = {
  width: 800,
  height: 600
}

export function BonusGames({ slug }: IBonusGamesProps) {
  interface IBonusGamesParameters extends ICanvasParameters {
    moduleId: number
    playerId: number
    slug: string
    getProgressUrl: string
    updateProgressUrl: string
  }

  const module = useModuleBySlug(slug)
  const { playerId, isPreview } = usePlayer()
  const [searchParams] = useSearchParams()
  const moduleVariant = Number(searchParams.get('moduleVariant')) || 0
  const hubUrl = usePlayerDashboardPath()
  useEffectAddScript(fimCdnAnimateUrl('/lib/math.js'))
  if (!module) return <Loading />

  const propsCanvas = new CanvasProperties<IBonusGamesParameters>()

  propsCanvas.preview = isPreview
  //Set whether we are in PWA Mode here.
  //propsCanvas.PWAMode = AppState.PwaMode

  //set the js source
  propsCanvas.jsSrc = `${module.jsClass}.js`

  propsCanvas.name = module.jsClass || module.slug || ''
  //propsCanvas.BgColor = model.Module.ModuleEx.BgColor
  propsCanvas.width = ModuleConstants.width
  propsCanvas.height = ModuleConstants.height
  //propsCanvas.IsResponsiveCompatible = model.Module.IsResponsive

  propsCanvas.parameters.playerId = playerId
  propsCanvas.parameters.moduleId = module.id
  propsCanvas.parameters.moduleVariant = moduleVariant
  //paramsTyped.gameFlag") = moduleGame.GameFlag
  propsCanvas.parameters.slug = module.slug
  propsCanvas.parameters.getProgressUrl = ApiMethods.get
  propsCanvas.parameters.updateProgressUrl = ApiMethods.update

  //function moduleAreaSlug = (id: ModuleArea) =>
  //{
  //    return
  //    switch (id)
  //    {
  //        case ModuleArea.bonus = 6,
  //        case ModuleArea.mw = 7,
  //        case ModuleArea.k2 = 8,
  //        case ModuleArea.ct = 10,

  //    }
  //}

  propsCanvas.parameters.hubUrl = hubUrl

  //FINDME: propsCanvas.pwaMode = model.PWAMode

  return (
    <ModuleLayout moduleId={module.id} isLegacyModule>
      <Canvas {...propsCanvas} />
    </ModuleLayout>
  )
}
